/* Rio Grand product photo viewer (desktop only, >= 750px).
   Adds: prev/next + counter, click-to-zoom with mouse pan, keyboard shortcuts,
   fit-to-screen photos. Mobile keeps the theme's own pinch-zoom. */
(function () {
  if (window.__rioZoomUI) return;
  window.__rioZoomUI = true;

  var MQ = window.matchMedia('(min-width: 750px)');
  var SCALE = 2;
  var ZOOMED = 'rio-zoomed';
  var ICON_PREV = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="m16.5 16.5-3.6-3.6M8.5 6v5M6 8.5h5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var ICON_MINUS = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="m16.5 16.5-3.6-3.6M6 8.5h5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function openDialog() {
    return document.querySelector('zoom-dialog dialog[open]');
  }

  function items(d) {
    return [].slice.call(d.querySelectorAll('.dialog-zoomed-gallery > li'));
  }

  function currentIndex(d) {
    var list = items(d);
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < list.length; i++) {
      var dist = Math.abs(list[i].offsetTop - d.scrollTop);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function zoomedItem(d) {
    return d ? d.querySelector('.dialog-zoomed-gallery > li.' + ZOOMED) : null;
  }

  function unzoomAll(d) {
    if (!d) return;
    items(d).forEach(function (li) {
      li.classList.remove(ZOOMED);
    });
    syncBar(d);
  }

  function setOrigin(li, clientX, clientY) {
    var box = li.querySelector('.product-media');
    if (!box) return;
    var r = box.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var ox = 0.5;
    var oy = 0.5;
    // Only pan along an axis when the zoomed photo is bigger than the window on that axis
    if (r.width * SCALE > li.clientWidth - 40) ox = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
    if (r.height * SCALE > li.clientHeight - 40) oy = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
    li.style.setProperty('--rio-ox', (ox * 100).toFixed(1) + '%');
    li.style.setProperty('--rio-oy', (oy * 100).toFixed(1) + '%');
  }

  function zoomIn(li, clientX, clientY) {
    var d = li.closest('dialog');
    unzoomAll(d);
    li.style.setProperty('--rio-scale', String(SCALE));
    if (typeof clientX === 'number') {
      setOrigin(li, clientX, clientY);
    } else {
      li.style.setProperty('--rio-ox', '50%');
      li.style.setProperty('--rio-oy', '50%');
    }
    li.classList.add(ZOOMED);
    syncBar(d);
  }

  function zoomOut(li) {
    li.classList.remove(ZOOMED);
    syncBar(li.closest('dialog'));
  }

  function go(d, delta) {
    var zoomEl = d.closest('zoom-dialog');
    var list = items(d);
    var next = currentIndex(d) + delta;
    if (!zoomEl || next < 0 || next >= list.length) return;
    unzoomAll(d);
    if (typeof zoomEl.selectThumbnail === 'function') {
      zoomEl.selectThumbnail(next, { behavior: 'smooth' });
    } else {
      list[next].scrollIntoView({ behavior: 'smooth' });
    }
  }

  function ensureBar(d) {
    var bar = d.querySelector('.rio-zoom-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'rio-zoom-bar';
    bar.setAttribute('role', 'toolbar');
    bar.setAttribute('aria-label', 'Photo viewer');
    bar.innerHTML =
      '<button type="button" class="rio-zoom-bar__btn" data-rio="prev" aria-label="Previous photo">' + ICON_PREV + '</button>' +
      '<span class="rio-zoom-bar__count" aria-live="polite"></span>' +
      '<button type="button" class="rio-zoom-bar__btn" data-rio="next" aria-label="Next photo">' + ICON_NEXT + '</button>' +
      '<span class="rio-zoom-bar__sep" aria-hidden="true"></span>' +
      '<button type="button" class="rio-zoom-bar__btn" data-rio="zoom" aria-label="Zoom in" aria-pressed="false"></button>' +
      '<span class="rio-zoom-bar__hint"></span>';
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rio]');
      if (!btn) return;
      e.stopPropagation();
      var act = btn.getAttribute('data-rio');
      if (act === 'prev') go(d, -1);
      else if (act === 'next') go(d, 1);
      else if (act === 'zoom') toggleCurrent(d);
    });
    d.appendChild(bar);
    var timer;
    d.addEventListener(
      'scroll',
      function () {
        var z = zoomedItem(d);
        if (z && Math.abs(z.offsetTop - d.scrollTop) > 8) z.classList.remove(ZOOMED);
        clearTimeout(timer);
        timer = setTimeout(function () {
          syncBar(d);
        }, 60);
      },
      { passive: true }
    );
    return bar;
  }

  function syncBar(d) {
    if (!d) return;
    var bar = d.querySelector('.rio-zoom-bar');
    if (!bar) return;
    var list = items(d);
    var idx = currentIndex(d);
    var zoomed = !!zoomedItem(d);
    var li = list[idx];
    var isImage = !!(li && li.classList.contains('product-media-container--image'));
    bar.querySelector('.rio-zoom-bar__count').textContent = list.length ? idx + 1 + ' / ' + list.length : '';
    bar.querySelector('[data-rio="prev"]').disabled = idx <= 0;
    bar.querySelector('[data-rio="next"]').disabled = idx >= list.length - 1;
    var z = bar.querySelector('[data-rio="zoom"]');
    z.innerHTML = zoomed ? ICON_MINUS : ICON_PLUS;
    z.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
    z.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    z.disabled = !isImage;
    bar.querySelector('.rio-zoom-bar__hint').textContent = zoomed ? 'Move your mouse to look around' : 'Click the photo to zoom';
    bar.classList.toggle('is-single', list.length < 2);
  }

  function toggleCurrent(d) {
    var list = items(d);
    var li = list[currentIndex(d)];
    if (!li || !li.classList.contains('product-media-container--image')) return;
    if (li.classList.contains(ZOOMED)) zoomOut(li);
    else zoomIn(li);
  }

  // Click on a photo toggles zoom instead of closing the viewer (the theme's default).
  // Clicking the empty area around the photo still closes it.
  document.addEventListener(
    'click',
    function (e) {
      if (!MQ.matches) return;
      var d = openDialog();
      if (!d || !d.contains(e.target) || !e.target.closest) return;
      var box = e.target.closest('.dialog-zoomed-gallery .product-media');
      if (!box) return;
      var li = box.closest('li.product-media-container--image');
      if (!li) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (li.classList.contains(ZOOMED)) zoomOut(li);
      else zoomIn(li, e.clientX, e.clientY);
    },
    true
  );

  document.addEventListener(
    'mousemove',
    function (e) {
      var d = openDialog();
      var li = zoomedItem(d);
      if (li) setOrigin(li, e.clientX, e.clientY);
    },
    { passive: true }
  );

  // Scrolling the wheel while zoomed just leaves zoom (instead of jumping to another photo).
  document.addEventListener(
    'wheel',
    function (e) {
      var d = openDialog();
      var li = zoomedItem(d);
      if (!li || !MQ.matches) return;
      e.preventDefault();
      zoomOut(li);
    },
    { passive: false, capture: true }
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (!MQ.matches) return;
      var d = openDialog();
      if (!d || e.ctrlKey || e.metaKey || e.altKey) return;
      var key = e.key;
      if (key === 'Escape') {
        var z = zoomedItem(d);
        if (z) {
          e.preventDefault();
          e.stopImmediatePropagation();
          zoomOut(z);
        }
        return;
      }
      if (key === 'ArrowRight' || key === 'ArrowDown' || key === 'PageDown') {
        e.preventDefault();
        go(d, 1);
      } else if (key === 'ArrowLeft' || key === 'ArrowUp' || key === 'PageUp') {
        e.preventDefault();
        go(d, -1);
      } else if (key === '+' || key === '=') {
        e.preventDefault();
        var li = items(d)[currentIndex(d)];
        if (li && li.classList.contains('product-media-container--image') && !li.classList.contains(ZOOMED)) zoomIn(li);
      } else if (key === '-' || key === '_') {
        e.preventDefault();
        var cur = zoomedItem(d);
        if (cur) zoomOut(cur);
      }
    },
    true
  );

  // dialog 'close' does not bubble, so listen in the capture phase
  document.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('zoom-dialog dialog')) unzoomAll(e.target);
    },
    true
  );

  function onOpen(d) {
    if (!MQ.matches) return;
    ensureBar(d);
    setTimeout(function () {
      syncBar(d);
    }, 80);
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t && t.matches && t.matches('zoom-dialog dialog[open]')) onOpen(t);
    }
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
})();
